import { render, staticRenderFns } from "./HomeRegularUser.vue?vue&type=template&id=7c580a87&scoped=true"
import script from "./HomeRegularUser.vue?vue&type=script&lang=js"
export * from "./HomeRegularUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c580a87",
  null
  
)

export default component.exports